export default "__VITE_ASSET__CZcc$aPU__"